<script>
import Modal from "./Modal";

export default {
  mixins: [Modal],

  mounted() {
    // Alleen deze specifieke popup opent automatisch bij laden
    this.open();
  }
};
</script>